import React, { useRef } from 'react'
import { IconButton } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { useDeleteInvitationMutation } from '../../../../generated/graphql'
import {
  ConfirmDialogue,
  ConfirmDialogueRef,
} from '../../../../@ui/containers/modals/confirm.dialogue'
import { useTheme } from '../../../../hooks/theme.hook'
import Toast from 'react-native-root-toast'
import { MessageType } from '../../../../utils/message-type'

interface DeleteInvitationButtonProps {
  invitationId: string
  onDeleted?: () => void
}

export const DeleteInvitationButton: React.FC<DeleteInvitationButtonProps> = ({
  invitationId,
  onDeleted,
}) => {
  const { t } = useTranslation('nodes')
  const theme = useTheme()
  const confirmDialogRef = useRef<ConfirmDialogueRef>(null)
  const [deleteInvitation, { loading }] = useDeleteInvitationMutation()

  const handleDelete = async () => {
    try {
      await deleteInvitation({
        variables: { id: invitationId },
      })

      Toast.show(t('invitation-deleted-successfully'), MessageType.info)
      onDeleted?.()
    } catch (error) {
      console.error('Error deleting invitation:', error)
      Toast.show(t('error-deleting-invitation'), MessageType.error)
      return false // Prevent dialog from closing on error
    }
  }

  const confirmDelete = () => {
    confirmDialogRef.current?.open()
  }

  return (
    <>
      <IconButton
        icon="delete"
        size={20}
        iconColor={theme.colors.error}
        onPress={confirmDelete}
        disabled={loading}
      />
      <ConfirmDialogue
        ref={confirmDialogRef}
        label={t('delete-invitation-confirm')}
        acceptLabel={t('delete')}
        cancelLabel={t('cancel')}
        onContinue={handleDelete}
      />
    </>
  )
}
